import { useEffect, useState } from "react";

export const useDelayedLoading = (loading: boolean, delayMs = 500): boolean => {
  const [delayedLoading, setDelayedLoading] = useState(false);

  useEffect(() => {
    if (!loading) {
      setDelayedLoading(false);
      return;
    }

    const timer = setTimeout(() => {
      setDelayedLoading(true);
    }, delayMs);

    return () => clearTimeout(timer);
  }, [loading, delayMs]);

  return delayedLoading;
};
